export default __webpack_public_path__ + "static/WC-2-white-a3ff4664397b0a7e552f6657f00d4f2b.png";